import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { validateIdCardNo } from '@/utils/validate';
import { typeMapObj } from './util.js';
export default {
  props: {
    editPersonnelVisible: {
      type: Boolean,
      default: false
    },
    editPersonelObj: {
      type: Object,
      default: () => {}
    },
    professionInfo: {
      type: Array,
      default: () => {}
    },
    policyPurpose: {
      type: String,
      default: 'other'
    },
    insurancePlan: {
      type: Array,
      default: () => {}
    },
    occupationTypeOptions: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    editPersonnelVisible: {
      handler(val) {
        if (val) {
          this.$set(this.form, 'jobNumber', this.editPersonelObj.jobNumber);
          this.$set(this.form, 'type', this.editPersonelObj.type);
          this.$set(this.form, 'name', this.editPersonelObj.name);
          this.$set(this.form, 'identificationType', this.editPersonelObj.identificationType);
          this.$set(this.form, 'idNumber', this.editPersonelObj.idNumber);
          this.$set(this.form, 'startAt', this.editPersonelObj.startAt);
          this.$set(this.form, 'premium', this.editPersonelObj.premium);
          this.$set(this.form, 'remark', this.editPersonelObj.remark);
          if (this.policyPurpose === 'groupInsurance') {
            this.$set(this.form, 'insurancePlanCode', this.editPersonelObj.insurancePlanCode);
            this.$set(this.form, 'occupationType', this.editPersonelObj.occupationType);
            this.$set(this.form, 'contractCompany', this.editPersonelObj.contractCompany);
            this.$set(this.form, 'dispatchCompany', this.editPersonelObj.dispatchCompany);
          }
        }
      },
      immediate: true
    }
  },
  computed: {
    rules() {
      return {
        jobNumber: [{
          required: true,
          message: this.$t('请选择') + this.$t('工种'),
          trigger: 'change'
        }],
        insurancePlanCode: [{
          required: true,
          message: '请选择保险方案',
          trigger: 'change'
        }],
        occupationType: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('工种类别'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        identificationType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        dispatchCompany: [{
          required: true,
          trigger: 'blur',
          message: '请输入实际工作单位（派遣单位）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        contractCompany: [{
          required: true,
          trigger: 'blur',
          message: '请输入劳动合同单位（合同主体）',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('名称'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('责任起期')
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: this.$t('请输入长度200以内的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }]
      };
    }
  },
  data() {
    return {
      form: {
        jobNumber: '',
        occupationType: '',
        InstanceType: '',
        name: '',
        identificationType: '',
        idNumber: '',
        startAt: '',
        premium: '',
        remark: ''
      },
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      typeMapObj: typeMapObj
    };
  },
  methods: {
    validateCard(rule, idcard, callback) {
      let idCardTrim = (idcard === null || idcard === void 0 ? void 0 : idcard.trim()) || '';
      if (!validateIdCardNo(idCardTrim) || idCardTrim == '') {
        callback(new Error(this.$t('请输入正确的身份证号')));
      } else {
        callback();
      }
    },
    cancel() {
      this.$emit('update:editPersonnelVisible', false);
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          var _this$form$idNumber;
          let occupation = this.professionInfo.find(item => {
            return item.jobNumber == this.form.jobNumber;
          });
          let name = this.form.name;
          let obj = {
            occupation: (occupation === null || occupation === void 0 ? void 0 : occupation.occupation) || '',
            jobNumber: this.form.jobNumber,
            type: this.form.type,
            name: (name === null || name === void 0 ? void 0 : name.trim()) || '',
            identificationType: this.form.identificationType,
            idNumber: ((_this$form$idNumber = this.form.idNumber) === null || _this$form$idNumber === void 0 ? void 0 : _this$form$idNumber.trim()) || '',
            startAt: this.form.startAt,
            premium: this.form.premium,
            remark: this.form.remark ? this.form.remark.trim() : '',
            index: this.editPersonelObj.index,
            endAt: this.editPersonelObj.endAt,
            rowKey: this.editPersonelObj.rowKey
          };
          if (this.policyPurpose === 'groupInsurance') {
            var _this$form$occupation, _this$form$contractCo, _this$form$dispatchCo;
            obj.occupationType = ((_this$form$occupation = this.form.occupationType) === null || _this$form$occupation === void 0 ? void 0 : _this$form$occupation.trim()) || '';
            obj.insurancePlanCode = this.form.insurancePlanCode;
            let planObj = this.insurancePlan.filter(item => item.mark === this.form.insurancePlanCode);
            console.log(planObj);
            obj.insurancePlanName = (planObj === null || planObj === void 0 ? void 0 : planObj.length) > 0 ? planObj[0].name : '';
            obj.contractCompany = ((_this$form$contractCo = this.form.contractCompany) === null || _this$form$contractCo === void 0 ? void 0 : _this$form$contractCo.trim()) || '';
            obj.dispatchCompany = ((_this$form$dispatchCo = this.form.dispatchCompany) === null || _this$form$dispatchCo === void 0 ? void 0 : _this$form$dispatchCo.trim()) || '';
          }
          this.$emit('editPersonnelSave', obj);
        }
      });
    },
    changeInsurancePlan(value) {
      this.form.occupationType = this.occupationTypeOptions[value] || '';
      this.$refs.dataFrom.validateField('occupationType');
    }
  }
};